// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7cfbc2a0","239":"7c72e506","453":"ee1e3270","455":"c774fcb9"}[chunkId] + ".chunk.js";
};